/* global gsap */

// TODO: keyboard support,
// add escape listener for close
// add focus trap

class navCta extends HTMLElement {
  constructor() {
    super();

    this.opened = false;
    this.buildTl();
    this.onKeyup = this.onKeyup.bind(this);
  }

  connectedCallback() {
    this.buttons = document.querySelectorAll('[data-element="nav-cta"]');
    this.buttons.forEach((el) => {
      el.addEventListener('click', (event) => this.onClick(event));
    });

    this.closeButton = document.querySelector('[data-element="nav-cta-close"]');
    this.closeButton.addEventListener('click', (event) => this.onClick(event));

    this.backdrop = document.querySelector('.nav-cta-flyout-bg');
    this.backdrop.addEventListener('click', (event) => this.onClick(event));
  }

  buildTl() {
    this.tl = gsap.timeline({
      paused: true,
      defaults: {
        duration: 0.25,
        ease: 'power1.in',
      },
    }).to('[data-element="nav-flyout"]', {
      display: 'grid',
      opacity: 1,
    }).to('[data-element="nav-flyout-panel"]', {
      display: 'block',
      opacity: 1,
      x: 0,
      ease: 'sine.out',
    });
  }

  onKeyup(event) {
    if (event.key === 'Escape') {
      this.opened = false;
      this.toggleFlyout();
    }
  }

  onClick(event) {
    event.preventDefault();
    this.opened = !this.opened;
    // Always play from the beginning,
    // in case of a reset from resizing window
    event.target.setAttribute('aria-expanded', this.opened);
    this.toggleFlyout();
  }

  toggleFlyout() {
    this.opened ? this.tl.play(0) : this.tl.reverse();
    document.documentElement.classList.toggle('cta-flyout-open', this.opened);

    // Only bind escape while the flyout is open
    if (this.opened) {
      document.addEventListener('keyup', this.onKeyup);
    } else {
      document.removeEventListener('keyup', this.onKeyup);
    }
  }
}

customElements.define('nav-cta', navCta);
